<template>

<v-app style="background: #eeeeee;">
    
    <NavAdministration :viewNotificactions="false"/>
    <v-main v-if="accessAdmin"
        :style="{'background-image': 'url(' + require('../../../assets/back2.jpg') + ')'}"
    >
        <v-container fluid style="opacity:1">  
            <v-card class="mx-auto">
                <v-overlay :value="overlay">
                    <v-progress-circular
                        indeterminate
                        :absolute=true
                        size="64"
                    ></v-progress-circular>
                </v-overlay>
                <v-card-text class="pb-0">
                    <v-alert
                        color="primary"
                        border="left"
                        dense
                        elevation="2"
                        colored-border
                        icon="mdi-medical-bag"
                    >
                        Campañas de laboratorio
                    </v-alert>
                </v-card-text>
                <v-col cols="12">
                    <v-row>
                        <v-col
                            cols="12"
                            sm="3"
                            class="py-0"
                        >
                            <v-select
                                label="Estado"
                                v-model=stateCamp
                                :items= states
                                item-value="status_id"
                                item-text="name"
                                prepend-icon="mdi-clock-alert"
                                @change="getDataComponent"
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                </v-col>
                <v-expansion-panels
                    inset
                    focusable 
                    :multiple=false
                    v-if="campaigns.length>0"
                >
                    <v-expansion-panel 
                        v-for="(campaign , x) in campaigns"
                        :key=x
                        :class="`campana_laboratorio_id_${campaign.campana_laboratorio_id}`"
                        :data-class="`campana_laboratorio_id_${campaign.campana_laboratorio_id}`"
                    >
                        <v-expansion-panel-header 
                            v-slot="{ open }"
                            @click=getOrders(campaign.campana_laboratorio_id)
                        >
                            <v-row no-gutters>
                            <v-col cols="3">{{campaign.descripcion}}</v-col>
                            <v-col
                                cols="9"
                                class="text--secondary"
                            >
                                <v-fade-transition leave-absolute>
                                <v-row
                                    no-gutters
                                    style="width: 100%"
                                >
                                    <v-col cols="3"><b>Fecha:</b> {{campaign.fecha}} </v-col>
                                    <v-col cols="4"><b>Estatus:</b> {{campaign.description}} </v-col>
                                    <v-col cols="3">
                                        <b>Faltantes: </b><span color="error">{{campaign.faltantes}} / {{campaign.total}}</span>
                                    </v-col>
                                </v-row>
                                </v-fade-transition>
                            </v-col>
                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row
                                justify="space-around"
                                no-gutters
                            >
                                <v-col cols="12" class="mt-2">
                                    <v-text-field
                                        v-model="campaign.search"
                                        append-icon="mdi-magnify"
                                        label="Buscar por cualquier columna"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                    <v-data-table
                                        :headers="headers"
                                        :items="campaign.orders"
                                        :search="campaign.search"
                                    >
                                        <template v-slot:item.quote_id="{ item }">
                                            <a  
                                                target="_blank" 
                                                :href="`https://innoclinica.evalua.com.ec/ventas/control/verCotizacion2?quoteId=${item.quote_id}`">{{item.quote_id}}
                                            </a>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                            <v-icon  
                                                @click="detailOrder(item)"
                                                v-if="item.status_id_order != 'OLST_CANCELADA'"
                                            >
                                                mdi-file-document
                                            </v-icon>
                                            <StatusOrderComponent
                                                v-if="item.status_id_order != 'OLST_COMPLETADA'"
                                                :status=item.status_id_order
                                                :idOrder=parseInt(item.olab_id)
                                                @setOverlay = setOverlay
                                                @updateStatusOrder = updateStatusOrder
                                            />
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-col v-else>
                    <v-alert
                    color="info"
                    border="left"
                    dense
                    elevation="2"
                    colored-border
                    icon="mdi-alert-circle-outline"
                >
                    No existen campañas
                    </v-alert>
                </v-col>
                <DetailOrderComponent     
                    :dialogOrder=dialogOrder
                    :dataDetailOrder=dataDetailOrder
                    :state=state
                    :overlay=overlay
                    @closeDialog =closeDialog
                    @setFileC = setFileCharge
                    @setOverlay= setOverlay
                    @setState = setState
                />
            </v-card>
        </v-container>
    </v-main>
</v-app>

</template>


<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import NavAdministration from '../../base/NavPrivateComponent'
import DetailOrderComponent from '../../base/DetailOrderComponent'
import StatusOrderComponent from '../../base/StatusOrderComponent'

export default{
    name: "PanelCampaignsComponent",
    components: {
        NavAdministration,
        DetailOrderComponent,
        StatusOrderComponent
    },
    data:()=>({
        headers:[
            { text: 'Nº Orden', value: 'olab_id' },
            { text: 'Cotización', value: 'quote_id' },
            { text: 'Cliente', value: 'cliente' },
            { text: 'Paciente', value: 'paciente' },
            { text: 'Médico', value: 'doctor' },
            { text: 'Fecha', value: 'fecha' },
            { text: 'Estado', value: 'status_order' },
            { text: 'Acción', value: 'action' }
        ],
        states:[
            {status_id: 'CAMP_CREADA', name: 'Activas'},
            {status_id: 'CAMP_COMPLETADA', name:'Completadas'},
            {status_id: 'CAMP_CANCELADA', name:'Canceladas'}
        ],
        dataDetailOrder:{
            order:'',
            patient:'',
            doctor:'',
            date:'',
            identification:'',
            company:'',
            empresa_id:'',
            details:[]
        },
        campaigns:[],
        stateCamp: 'CAMP_CREADA',
        state:'',
        overlay: false,
        dialogOrder:false,
    }),
    computed:{
        ...mapState([
            'idActionsRol',
            'loadingTable',
            'user',
            'url',
            'urlApi',
            'pathFileOrder',
        ]),

        dateRangeText () {
            return this.dates.join(' ~ ')
        },

        accessAdmin (){
            return typeof this.idActionsRol.find(e => e === 'ACCESO_WEB_ADMIN') != "undefined";
        },

        
        
    },
    methods:{
        ...mapMutations(['setUrl','setLoadingTable']),

        ...mapActions(['requestApi','alertNotification']),

        getDataComponent(){
            this.overlay = true
            this.setUrl('panel-campanas')
            this.requestApi({
                method:'GET',
                data:{
                    state: this.stateCamp,
                }
            }).then(res=>{
                this.overlay = false
                this.campaigns = res.data._embedded.panel_campanas.map((obj) => {
                    obj.orders =[]
                    obj.search = ''
                    return obj
                })
                console.log(res)

            }).catch(()=>{
                this.overlay = false
            })

        },

        getOrders(id){
            //console.log(data)
           /*  var path = data.path || (data.composedPath && data.composedPath());
            console.log(path)
            let id = path[0].offsetParent.offsetParent.classList[1].split('_')  */
            //let id = data

            if(typeof id!='undefined'){

                this.overlay = true
                this.setUrl('panel-campanas/'+id)
                this.requestApi({
                    method:'GET',
                    data:{}
                }).then(res=>{
                    this.overlay = false
                    console.log( res)
                    let obj = this.campaigns.find(e => e.campana_laboratorio_id == parseInt(id));
                    let index = this.campaigns.indexOf(obj)
                    this.campaigns[index].orders = res.data.orders

                }).catch(()=>{
                    this.overlay = false
                })
                console.log()
            }
        },

        detailOrder(item){
            console.log(item)
            this.overlay= true
            this.setLoadingTable(true)
            this.setUrl('ordenes-laboratorio/'+item.olab_id)
            this.dataDetailOrder.order= "#"+item.olab_id
            this.dataDetailOrder.patient= item.paciente
            this.dataDetailOrder.doctor= item.doctor
            this.dataDetailOrder.date= item.fecha
            this.dataDetailOrder.identification = item.identification
            this.dataDetailOrder.empresa_id = item.empresa_id
            this.requestApi({
                method:'GET',
                data:{}
            }).then(res=>{
                console.log(res)
                let proveedor_id = ''
                let x=0
                let rowspan = ''
                let archive =''
                this.dataDetailOrder.company =  res.data.company
                this.dataDetailOrder.details = res.data.items.map((obj)=>{
                    let print = proveedor_id != obj.proveedor_id
                    obj.proveedor=[]
                    if(print){
                        rowspan = typeof res.data.rowspan[x] != 'undefined' ? res.data.rowspan[x].rowspan  : ''
                        archive = typeof res.data.rowspan[x] != 'undefined' ? this.pathFileOrder+res.data.rowspan[x].ruta_documento+'.pdf'  : ''
                        if(typeof res.data.rowspan[x] != 'undefined')
                            obj.proveedor= res.data.rowspan[x].group_name

                        obj.path='sdsd'
                        obj.olab_id = item.olab_id
                        x++
                    }else{
                        archive=false
                    }
                    obj.check = false
                    obj.print = print
                    obj.rowspan = rowspan
                    obj.archive = archive
                    proveedor_id = obj.proveedor_id
                    obj.fileCharged= false
                    return obj
                })
                this.dialogOrder=true
                const match = e => e.status_id === "OLIT_SOLICITADO"
                let stateOrder = res.data.items.find(match)
                typeof stateOrder != 'undefined'
                    ? this.state= "Solicitado" 
                    : this.state= "Completado" 
                this.overlay= false
                console.log(this.dataDetailOrder)
            
            })
            
        },
        
        closeDialog(state){
            this.dialogOrder=state
            Object.assign(this.dataDetailOrder,this.dataDefaultDetailOrder)
            this.file=[]
        },

        setFileCharge(detail){
            let index = this.dataDetailOrder.details.indexOf(detail)
            this.dataDetailOrder.details[index].fileCharged=false
        },

        setOverlay(state){
            this.overlay= state
        },

        setState(state){
            this.state = state
        },

        updateStatusOrder(data){
            
            for(let campaign of this.campaigns){
                let order = campaign.orders.find(e => e.olab_id == data.idOrder)
                if(typeof order != 'undefined'){
                    
                    if(data.status){
                        campaign.faltantes -= 1
                        order.status_id_order= 'OLST_CANCELADA'
                        order.status_order = 'Cancelada'
                    }else{  
                        campaign.faltantes += 1
                        order.status_id_order= 'OLST_SOLICITADA'
                        order.status_order = 'solicitada'
                    }
                    break
                }
            }
            console.log(this.campaigns,data)
        }
    },
    
    mounted(){
        this.getDataComponent()
    }
}
</script>
<style scope>
    td{
        font-size: 13px!important;
    }

</style>